
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Mail, Lock, User, Phone } from "lucide-react";

interface PersonalInfoSectionProps {
  name: string;
  setName: (name: string) => void;
  email: string;
  setEmail: (email: string) => void;
  password: string;
  setPassword: (password: string) => void;
  phone: string;
  setPhone: (phone: string) => void;
}

const PersonalInfoSection = ({
  name,
  setName,
  email,
  setEmail,
  password,
  setPassword,
  phone,
  setPhone
}: PersonalInfoSectionProps) => {
  return (
    <>
      <div>
        <Label htmlFor="name" className="block text-sm font-medium text-gray-700">
          Nom complet
        </Label>
        <div className="mt-1 flex rounded-md shadow-sm">
          <span className="inline-flex items-center rounded-l-md border border-r-0 border-gray-300 bg-gray-50 px-3 text-gray-500">
            <User className="h-4 w-4" />
          </span>
          <Input
            id="name"
            name="name"
            type="text"
            required
            className="block w-full flex-1 rounded-none rounded-r-md border-gray-300 focus:border-socialsync-500 focus:ring-socialsync-500 sm:text-sm"
            placeholder="John Doe"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
      </div>

      <div>
        <Label htmlFor="phone" className="block text-sm font-medium text-gray-700">
          Numéro de téléphone *
        </Label>
        <div className="mt-1 flex rounded-md shadow-sm">
          <span className="inline-flex items-center rounded-l-md border border-r-0 border-gray-300 bg-gray-50 px-3 text-gray-500">
            <Phone className="h-4 w-4" />
          </span>
          <Input
            id="phone"
            name="phone"
            type="tel"
            required
            className="block w-full flex-1 rounded-none rounded-r-md border-gray-300 focus:border-socialsync-500 focus:ring-socialsync-500 sm:text-sm"
            placeholder="+33612345678"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            pattern="^(\+[0-9]{1,3}|0)[0-9]{9,}$"
            title="Veuillez entrer un numéro de téléphone valide (format international +33... ou commençant par 0)"
          />
        </div>
        <p className="mt-1 text-xs text-gray-500">
          Format: +33612345678 ou 0612345678
        </p>
      </div>

      <div>
        <Label htmlFor="email" className="block text-sm font-medium text-gray-700">
          Adresse email *
        </Label>
        <div className="mt-1 flex rounded-md shadow-sm">
          <span className="inline-flex items-center rounded-l-md border border-r-0 border-gray-300 bg-gray-50 px-3 text-gray-500">
            <Mail className="h-4 w-4" />
          </span>
          <Input
            id="email"
            name="email"
            type="email"
            required
            className="block w-full flex-1 rounded-none rounded-r-md border-gray-300 focus:border-socialsync-500 focus:ring-socialsync-500 sm:text-sm"
            placeholder="exemple@email.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
      </div>

      <div>
        <Label htmlFor="password" className="block text-sm font-medium text-gray-700">
          Mot de passe *
        </Label>
        <div className="mt-1 flex rounded-md shadow-sm">
          <span className="inline-flex items-center rounded-l-md border border-r-0 border-gray-300 bg-gray-50 px-3 text-gray-500">
            <Lock className="h-4 w-4" />
          </span>
          <Input
            id="password"
            name="password"
            type="password"
            required
            className="block w-full flex-1 rounded-none rounded-r-md border-gray-300 focus:border-socialsync-500 focus:ring-socialsync-500 sm:text-sm"
            placeholder="••••••••"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            minLength={8}
          />
        </div>
      </div>
    </>
  );
};

export default PersonalInfoSection;
